<template>
  <div class="col-12">
    <DottedLineHeader :text="$t('more.bp_tests') + (userBPTest ? (' - ' + $t('more.date') + ': ') : '')" :value="userBPTest ? testDate : ''">
      <div class="d-flex toolbar-container">
        <MiniToolbar v-if="!printing" class="p-2" :buttons="toolbar" @clicked="toolbarClicked"/>
      </div>
    </DottedLineHeader>

    <Loading v-if="bpTestLoading"/>
    <Error v-if="bpTestLoadError && bpTestLoadError.status !== 404"/>
    <NoData v-if="!userBPTest || (!bpTestData && !bpTestLoading && (!bpTestLoadError || bpTestLoadError.status === 404))"/>
    <div v-if="userBPTest && !bpTestLoading && !bpTestLoadError" class="row bpresult">
      <div class="col-md-4">
        <span class="bpresult-title">{{$t('more.sys')}}: </span><span class="bpresult-value">{{bpTestData && bpTestData.sys}}</span>
      </div>
      <div class="col-md-4">
        <span class="bpresult-title">{{$t('more.dia')}}: </span><span class="bpresult-value">{{bpTestData && bpTestData.dia}}</span>
      </div>
      <div class="col-md-4">
        <span class="bpresult-title">{{$t('more.status')}}: </span><span class="bpresult-value">{{bpstatus}}</span>
      </div>
      <div class="col-md-4">
        <span class="bpresult-title">{{$t('more.hb_rate')}}: </span><span class="bpresult-value">{{bpTestData && bpTestData.hr}} {{$t("more.bpm")}}</span>
      </div>
      <div class="col-md-4 frowspan2">
        <span class="bpresult-title">{{$t('more.arithmies')}}: </span><span class="bpresult-value">
          <ul class="tc-tags">
            <li v-if="bpTestData && bpTestData.arr && bpTestData.arr > 0" arithmy="afib" tabindex="0" class="tc-tag tc-valid"><div class="tc-content"><div class="tc-tag-center"><span class="">Afib</span> </div></div></li>
            <li v-if="bpTestData && (bpTestData.hr > 100)" arithmy="tachycardia" tabindex="0" class="tc-tag tc-valid"><div class="tc-content"><div class="tc-tag-center"><span class="">Tachycardia</span> </div></div></li>
            <li v-if="bpTestData && (bpTestData.hr < 50)" arithmy="bradycardia" tabindex="0" class="tc-tag tc-valid"><div class="tc-content"><div class="tc-tag-center"><span class="">Bradycardia</span> </div></div></li>
            <li v-if="bpTestData && !(bpTestData.afib || (bpTestData.hr > 100) || (bpTestData.hr < 50))" arithmy="normal" tabindex="0" class="tc-tag tc-valid"><div class="tc-content"><div class="tc-tag-center"><span class="">Normal</span> </div></div></li>
          </ul>
        </span>
      </div>
      <div class="col-12">
        <span class="bpresult-title">{{$t('more.bp_test_description')}}: </span><span class="bpresult-value">{{testDescription}}</span>
      </div>
      <div class="col-12 bpresult-tags">
        <span>{{$t('more.tags')}}: </span><ul class="tc-tags">
          <li v-for="tag in tags" :key="tag" tabindex="0" class="tc-tag tc-valid"><div class="tc-content"><!----> <div class="tc-tag-center"><span class="">{{tag}}</span> <!----> </div> <!----></div></li>
        </ul>
      </div>
    </div>

    <b-modal id="modal-1" ref="modal" :title="$t('more.edit_tag')" :ok-title="$t('modal.ok')" :cancel-title="$t('modal.cancel')" @hidden="resetModel" @ok="handleEditTags">
        <div class="modal-body mx-3">
          <div class="form-group">
            <label for="tags_edit">{{ $t('more.annotation') }}</label>
            <vue-tags-input
              name="tags_edit"
              v-model="tag"
              :tags="editing_tags || tags"
              @tags-changed="newTags => editing_tags = newTags"
            />
          </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
// eslint-disable-next-line no-unused-vars
import persianDatePicker from 'persian-datepicker/dist/js/persian-datepicker'
import DefaultDatePickerOptions from '@/components/DefaultDatePickerOptions.js'
import VueTagsInput from '@johmun/vue-tags-input'
import PersianDate from 'persian-date'
import { mapState, mapActions } from 'vuex'
import DottedLineHeader from '@/components/DottedLineHeader.vue'
import MiniToolbar from '@/components/MiniToolbar.vue'
import NoData from '@/components/NoData.vue'
import Loading from '@/components/Loading.vue'
import Error from '@/components/Error.vue'

export default {
  components: {
    VueTagsInput,
    DottedLineHeader,
    MiniToolbar,
    NoData,
    Loading,
    Error
  },
  props: {
    sharedTest: Object,
    printing: Boolean,
    testIndex: Number,
    fetchedTests: Array,
    showMode: String
  },
  watch: {
    userBPTest: function (newValue) {
      this.requestData()
    }
  },
  computed: {
    ...mapState({
      testMinimalItems: state => state.test.bptestsMinimal.items,
      resultFrom: state => state.test.testsMinimalFrom,
      bpTestLoading: state => state.test.bpTestData.loading,
      bpTestLoadError: state => state.test.bpTestData.error
    }),
    userBPTest () {
      if (this.showMode === 'calendar') {
        return this.fetchedTests[this.testIndex]
      }

      if (!this.sharedTest || !this.sharedTest.last_tests || this.sharedTest.last_tests.length === 0) {
        return null
      }
      var bpTest = this.sharedTest.last_tests.filter(test => {
        return test.type === 'bp'
      })
      if (bpTest.length === 0) {
        return null
      }
      return bpTest[this.testIndex]
    },
    testDate () {
      var test = this.userBPTest
      if (!test) {
        return ''
      }
      return this.jdate(test.tested_at)
    },
    testDescription () {
      var test = this.userBPTest
      if (!test) {
        return ''
      }
      return test.description
    },
    tags () {
      var test = this.userBPTest
      if (!test) {
        return []
      }
      return test.tags || []
    },
    bpstatus () {
      if (!this.sharedTest || !this.bpTestData) {
        return ''
      }
      if (this.bpTestData.sys <= 120 && this.bpTestData.dia <= 80) {
        return this.$t('more.bp_status_normal')
      }
      if (this.bpTestData.sys > 120 && this.bpTestData.sys <= 129 && this.bpTestData.dia <= 80) {
        return this.$t('more.bp_status_medium')
      }
      if (this.bpTestData.sys > 130 && this.bpTestData.sys <= 139 && this.bpTestData.dia >= 90) {
        return this.$t('more.bp_status_high')
      }
      return this.$t('more.bp_status_unknown')
    },
    calendarOptions () {
      var opts = DefaultDatePickerOptions(false)
      opts['onSelect'] = this.onDateSelected
      opts['monthPicker'] = {
        'onSelect': this.onMonthSelected
      }
      opts['yearPicker'] = {
        'onSelect': this.onYearSelected
      }
      opts['navigator'] = {
        'onPrev': this.onPrev,
        'onNext': this.onNext
      }
      return opts
    },
    toolbar () {
      var tableHtml
      var whoTable = [
        ['وضعیت کیفی فشار خون برحسب WHO - mmHg'],
        ['دسته بندی فشار خون', 'سیستولیک', 'دیاستولیک'],
        ['فشار نرمال', 'کمتر از 120', 'کمتر از 80'],
        ['فشار متوسط', '120 - 129', 'کمتر از 80'],
        ['فشار بالا', '130 - 139', 'بیشتر از 90']
      ]
      tableHtml = '<table class="who-table" CELLPADDING="2" CELLSPACING="10" WIDTH="300px">'
      whoTable.forEach((row, rindex) => {
        tableHtml += '<tr>'
        row.forEach(col => {
          if (rindex > 1) {
            tableHtml += `<td>${col}</td>`
          } else if (rindex === 1) {
            tableHtml += `<th>${col}</th>`
          } else {
            tableHtml += `<td colspan="3">${col}</td>`
          }
        })
        tableHtml += '</tr>'
      })
      tableHtml += '</table>'

      var result = []
      if (this.testIndex === 0) {
        result.push({
          icon: 'sli-clock',
          id: 'bpresult-history',
          tip: 'more.history'
        })
        result.push({
          icon: 'sli-question',
          id: 'bpresult-question',
          tip: tableHtml,
          htmlContent: true
        })
        result.push({
          icon: 'sli-pin',
          id: 'bpresult-pin',
          tip: 'more.last_test'
        })
      }

      if (this.userBPTest) {
        result.push({
          icon: 'sli-tag',
          id: 'bpresult-tag',
          tip: 'more.edit_tag',
          small: true
        })
        result.push({
          icon: 'sli-bubbles',
          id: 'bpresult-discussion',
          tip: 'more.discussion',
          small: true
        })
        result.push({
          icon: 'sli-cloud-download',
          id: 'bpresult-download',
          tip: 'more.download_data',
          small: true,
          visible: this.can('shared.test', 'download')
        })
      }

      return result
    }
  },
  data: () => ({
    tag: '',
    editing_tags: null,
    editTagsSubmitted: false,
    resultFromDate: -1,
    resultToDate: -1,
    bpTestData: null,
    unsubscribe: null
  }),
  methods: {
    ...mapActions('test', ['testsMinimal', 'tests', 'editTestTags', 'testData']),
    resetModel () {
      this.editTagsSubmitted = false
      this.editing_tags = this.tags
    },
    handleEditTags (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.editTagsSubmitted = true
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$refs.modal.hide()
          var tags = this.editing_tags.map(tag => {
            return tag.text
          })

          var test = this.userBPTest
          if (!test) {
            return
          }
          this.editTestTags({testUuid: test.uuid, tags: tags})
        }
      })
    },
    jdate (unix) {
      if (!unix) {
        return ''
      }
      return new PersianDate(unix * 1000).toLocale('fa').format('D MMMM HH:mm')
    },
    toolbarClicked: function (id, button) {
      switch (button.icon) {
        case 'sli-clock':
          // datepicker will show up and no need to write code here
          break
        case 'sli-tag':
          this.editing_tags = this.tags
          this.$refs.modal.show()
          break
        case 'sli-pin':
          this.$emit('modeChanged', 'last')
          break
        case 'sli-bubbles':
          this.$emit('openDicussion', this.userBPTest.uuid, this.sharedTest.user)
          break
        case 'sli-cloud-download':
          const dataUrl = window.URL.createObjectURL(new Blob([JSON.stringify(this.bpTestData)]))
          var a = document.createElement('a')
          a.href = dataUrl
          a.download = this.userBPTest.uuid
          a.click()
          break
      }
    },
    initDatePicker: function () {
      $('#bpresult-history').off('focus click')
      $('#bpresult-history').on('focus click', (evt) => {
        this.showDataPicker(evt)
      })
    },
    showDataPicker: function (evt) {
      if (!this.sharedTest) {
        return
      }

      $('div[id|="persianDateInstance"]').remove()
      $('#bpresult-history').off('focus click')
      $('#bpresult-history').pDatepicker(this.calendarOptions)
      $('#bpresult-history').trigger('click')
      this.initDatePicker()
      this.getHighlightedDays()
    },
    getHighlightedDays: function () {
      setTimeout(() => {
        var days = $('td[data-date]:not(:has(span[class=\'other-month\']))')
        if (!days) {
          return
        }
        let resultFrom = days[0].dataset.date
        this.resultFromDate = this.jalaliToTimeStamp(resultFrom)
        this.resultToDate = this.jalaliToTimeStamp(days[days.length - 1].dataset.date, false)
        this.testsMinimal({userUuid: this.sharedTest.user.uuid, fromDate: this.resultFromDate, toDate: this.resultToDate, type: 'bp', resultFrom})
      }, 500)
    },
    jalaliToTimeStamp: function (date, start = true) {
      var x = date.match(/(\d{0,4}),(\d{0,2}),(\d{0,2})/)
      if (x.length < 4) {
        // date not valid
        return
      }
      x = x.map(function (e) {
        return parseInt(e, 10)
      })
      if (start) {
        return new PersianDate([x[1], x[2], x[3]]).startOf('day').format('X')
      } else {
        return new PersianDate([x[1], x[2], x[3]]).endOf('day').format('X')
      }
    },
    highlightDaysOnDatePicker (testMinimalItems) {
      if (!testMinimalItems) {
        return
      }
      var flags = testMinimalItems.value
      this.flags = flags
      var i = 0

      var x = this.resultFrom.match(/(\d{0,4}),(\d{0,2}),(\d{0,2})/)
      if (!x || x.length < 4) {
        // date not valid
        return
      }

      while (flags > 0) {
        if (flags & 1) {
          var date = `${x[1]},${x[2]},${i + 1}`
          $('td[data-date=\'' + date + '\'] span:first-child').addClass('highlighted-date')
        }

        flags /= 2
        i++
      }
    },
    onDateSelected: function (unixdate) {
      var date = new PersianDate(unixdate).format('YYYY,MM,DD')
      var fromDate = this.jalaliToTimeStamp(date)
      var toDate = this.jalaliToTimeStamp(date, false)
      this.tests({userUuid: this.sharedTest.user.uuid, fromDate: fromDate, toDate: toDate, type: 'bp', context: 'daily'})
      this.$emit('modeChanged', 'calendar')
    },
    onYearSelected: function (year) {
      this.getHighlightedDays()
    },
    onMonthSelected: function (monthIndex) {
      this.getHighlightedDays()
    },
    onNext: function (navigator) {
      this.getHighlightedDays()
    },
    onPrev: function (navigator) {
      this.getHighlightedDays()
    },
    requestData: function () {
      setTimeout(() => {
        var test = this.userBPTest
        if (test) {
          this.testData({uuid: test.uuid, type: 'bp'})
        }
      }, 500)
    }
  },
  created () {
    var that = this
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (that.testIndex === 0 && mutation.type === 'test/bptestsMinimalSuccess') { // only first test has date-picker
        that.highlightDaysOnDatePicker(mutation.payload)
      }
      /* if (mutation.type === 'test/bpTestsSuccess') {
        let tests = mutation.payload
        if (tests.length > 0) {
          this.testData({uuid: tests[0].uuid, type: 'bp'})
        }
      } */
      if (that.testIndex === 0 && mutation.type === 'test/bpTestsFailure') {
        if (mutation.payload.status === 404) {
          notify({
            text: this.$t('more.fetch_error'),
            theme: 'red'
          })
        }
      }
      if (mutation.type === 'test/bpTestDataSuccess') {
        if (that.userBPTest && that.userBPTest.uuid === mutation.payload.uuid) {
          this.bpTestData = mutation.payload.testData
        }
      }
      if (mutation.type === 'test/editTestTagsSuccess') {
        if (this.showMode === 'calendar' && this.fetchedTests[this.testIndex].uuid === mutation.payload.testUuid) {
          var test = {...this.fetchedTests[this.testIndex]}
          test.tags = mutation.payload.tags
          Vue.set(this.fetchedTests, this.testIndex, test)
        }
      }
    })
  },
  mounted () {
    this.initDatePicker()

    this.requestData()
  },
  destroyed () {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }
}
</script>

<style>
.bpresult {
  text-align: right;
  line-height: 2.5rem;
}
.bpresult span {
  display: inline-block;
}
.bpresult .bpresult-title {
  color: var(--blood-pressure-text-color);
  font-size: small;
}
.bpresult .bpresult-value {
  margin: 0 10px 0;
  font-weight: bold;
  color: var(--blood-pressure-value-color);
}
.toolbar-container {
  align-items: center;
}
.frowspan2 {
  flex: 1 1 66%;
}
</style>



// WEBPACK FOOTER //
// src/views/BloodPressureResult.vue